export const taskHeight = 76;
export const taskWidth = 116;
